var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2 text-info font-weight-bold"},[_c('i',{staticClass:"fa fa-info-circle mr-1"}),_vm._v("\n    "+_vm._s(_vm.$t('class-attendance-report-for-admin.absent_students_today'))+"\n  ")]),_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","max-height":"700"},scopedSlots:_vm._u([{key:"card_number",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.card_number)+"\n    ")]}},{key:"student_name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.student_name)+"\n    ")]}},{key:"gender",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.gender)+"\n    ")]}},{key:"father_name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.father_name)+"\n    ")]}},{key:"father_phone",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.father_phone)+"\n    ")]}},{key:"mother_name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.mother_name)+"\n    ")]}},{key:"mother_phone",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.mother_phone)+"\n    ")]}},{key:"absent_status",fn:function(ref){
var row = ref.row;
return [_c('span',{class:[
              'badge',
              row.absent_status === 'វត្តមាន'
                ? 'badge-success'
                : row.absent_status === 'អវត្តមាន'
                ? 'badge-danger'
                : row.absent_status === 'សុំច្បាប់'
                ? 'badge-info'
                :''
            ]},[_vm._v("\n            "+_vm._s(row.absent_status)+"\n          ")])]}},{key:"action",fn:function(ref){
            var row = ref.row;
return [_c('a',{staticClass:"text-primary mr-2",attrs:{"href":"#","title":"edit"},on:{"click":function($event){$event.preventDefault();return _vm.edit(row)}}},[_c('i',{staticClass:"fas fa-edit"})])]}}])}),_c('a-modal',{attrs:{"centered":true,"title":(_vm.edit_data && _vm.edit_data.card_number ? _vm.edit_data.card_number : '') +
        ' | ' +
        (_vm.edit_data && _vm.edit_data.student_name ? _vm.edit_data.student_name : ''),"footer":null},on:{"cancel":_vm.handleCancel},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('FormAction',{on:{"cancel":_vm.handleCancel}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }